import React, { useEffect, useState } from 'react'
import { useTranslation } from 'i18n'

import ReferralProgressBar from './ReferralProgressBar.jsx'
import { count, submit } from 'services/referral'
import './ReferralCard.scss'

const ReferralCard = ({
  imgUrl,
  media, // puck (BR-5452): rendered media node replacing the img/bg pair
  linkUrl,
  linkId,
  title,
  subtitle,
  ctaText,
  currentVotes,
  totalVotes,
  showProgressBar,
  showVoteCount = true,
  referralId,
  buttonColor,
  progressBarColor,
  progressBarCompleteColor,
  progressBarHighlightColor,
  onLinkClick,
  layout,
  // PUCK-BACKEND-GAP (BR-5452): no backend entity to vote against — tally
  // locally only (submit skipped). Remove when the backend supports it.
  mockVoting = false,
  cardClass,
  cardStyle,
}) => {
  const { t } = useTranslation('referral')
  const [highlight, setHighlight] = useState(false)
  const [realTimeVote, setRealTimeVote] = useState(0)

  const handleSubmitVote = async () => {
    if (!mockVoting) submit(referralId, linkId)
    setRealTimeVote(realTimeVote + 1)
    setHighlight(true)
    onLinkClick()
  }

  const assignLayoutClass = () => {
    if (layout === 'ONE_COLUMN') {
      return 'one-col'
    } else if (layout === 'TWO_COLUMN') {
      return 'two-col'
    } else {
      return 'three-col'
    }
  }

  const layoutClass = assignLayoutClass()

  return (
    <div
      className={`referral-card ${layoutClass} ${cardClass ?? ''}`}
      style={cardStyle}
    >
      {media ? (
        <div className="referral-card--item">{media}</div>
      ) : (
        <div
          className="referral-card--item"
          style={{ backgroundImage: `url(${imgUrl})` }}
        >
          <img className="referral-card--img" src={imgUrl} alt="cloud" />
        </div>
      )}
      <div className="referral-card--info">
        <div
          className="referral-card--title"
          dangerouslySetInnerHTML={{ __html: title }}
        ></div>
        <div
          className="referral-card--subtitle"
          dangerouslySetInnerHTML={{ __html: subtitle }}
        ></div>
        <div className="referral-card--progress">
          {showProgressBar && (
            <ReferralProgressBar
              currentVotes={currentVotes + realTimeVote}
              totalVotes={totalVotes}
              highlight={highlight}
              barColor={progressBarColor}
              completeColor={progressBarCompleteColor}
              highlightColor={progressBarHighlightColor}
              showVoteCount={showVoteCount}
            />
          )}
        </div>
        <div className="referral-card--cta">
          {linkUrl ? (
            <a
              className="referral-card--cta-button"
              href={linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleSubmitVote}
              style={{ backgroundColor: buttonColor }}
            >
              {ctaText || t('voteCta')}
            </a>
          ) : (
            // vote-only card (no target url, e.g. puck card without a
            // ReferralButton): same button, no navigation
            <button
              type="button"
              className="referral-card--cta-button"
              onClick={handleSubmitVote}
              style={{ backgroundColor: buttonColor, border: 'none', cursor: 'pointer' }}
            >
              {ctaText || t('voteCta')}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default ReferralCard
